import { io } from 'socket.io-client';
import baseURL from '../../utils/base-url';

export const socket = io(baseURL || '', {
  transports: ['websocket'],
  autoConnect: false,
});
